import React from "react";

import styled from "styled-components";

import { AutomationCommandProps } from "../types/automation";
import { SetChartPayload } from "../types/payloads";

const ChartCommandRender: React.FC<AutomationCommandProps> = ({ command }) => {
  const payload = command.payload as SetChartPayload;
  return (
    <RootContainer>
      Set Chart ({payload.product} {payload.chartType})
    </RootContainer>
  );
};

export default ChartCommandRender;

const RootContainer = styled.div``;
